import firebase from 'firebase/app';

export default class AxiosRefreshTokenStrategy {
  listeners = [];

  static EVENTS = {
    TOKEN_UPDATED: 'token:updated',
  };

  constructor(next, repeat) {
    this.repeat = repeat;
    this.next = next;
  }

  clearGuardData() {
    clearTimeout(this.guardTimerId);
    this.infiniteCycleGuardCounter = 0;
    this.guardTimerId = null;
  }

  infiniteLoopGuard() {
    if (this.infiniteCycleGuardCounter) {
      this.infiniteCycleGuardCounter += 1;
    } else {
      this.infiniteCycleGuardCounter = 1;
    }
    if (this.infiniteCycleGuardCounter > 3) {
      this.clearGuardData();
      return AxiosRefreshTokenStrategy.onUnauthorized();
    }
    if (!this.guardTimerId) {
      this.guardTimerId = setTimeout(() => this.clearGuardData(), 5000);
    }

    return null;
  }

  success(response) {
    return this.next.success(response);
  }

  fail(error) {
    if (!error.response) {
      throw this.next.fail(error);
    }

    if (error.response.status === 403 && error.config) {
      if (this.infiniteLoopGuard()) {
        throw new Error('Infinite loop');
      }

      return AxiosRefreshTokenStrategy.refreshToken()
        .then((token) => this.onTokenRefreshed(token))
        .then(() => this.repeatRequest(error))
        .catch(() => AxiosRefreshTokenStrategy.onUnauthorized());
    }

    if (error.response === 401) {
      return AxiosRefreshTokenStrategy.onUnauthorized();
    }

    throw this.next.fail(error);
  }

  static refreshToken() {
    if (!firebase.auth().currentUser) {
      return AxiosRefreshTokenStrategy.onUnauthorized();
    }

    return firebase.auth().currentUser.getIdToken(true);
  }

  repeatRequest(error) {
    return this.repeat(error.config);
  }

  onTokenRefreshed(token) {
    this.listeners.forEach((listener) => listener(token));
  }

  static async onUnauthorized() {
    await firebase.auth().signOut();
    throw new Error('Unauthorized');
  }

  on(event, cb) {
    if (event === AxiosRefreshTokenStrategy.TOKEN_UPDATED) {
      this.listeners.push(cb);
    }

    return () => this.off(event, cb);
  }

  off(event, cb) {
    if (event === AxiosRefreshTokenStrategy.TOKEN_UPDATED) {
      this.listeners = this.listeners.filter((l) => l !== cb);
    }
  }
}
